<br/>
<h5 class="card-title text-muted">Tools</h5>
<mat-divider></mat-divider>
<mat-progress-bar *ngIf="progress"
                  [color]="'primary'"
                  [mode]="'indeterminate'">
</mat-progress-bar>
<div class="table-container">
    <div class="table-loading-shade"
         *ngIf="isLoadingResults">
        <mat-spinner [diameter]="50" *ngIf="isLoadingResults"></mat-spinner>
    </div>

    <br/>

    <div class="table-box container">
        <div class="row">

            <div class="col-sm-3 col-xs-12">
                <mat-form-field style="width: 100%">
                    <mat-label>Location</mat-label>
                    <mat-select [(ngModel)]="selectedLocation" [disabled]="progress" required>
                        <mat-option *ngFor="let location of locations"
                                    [value]="location">{{location.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-sm-2 col-xs-12">
                <mat-form-field style="width: 100%">
                    <mat-label>From</mat-label>
                    <input matInput [disabled]="progress" [formControl]="fromDate" [matDatepicker]="fromDateId" required>
                    <mat-datepicker-toggle matSuffix [for]="fromDateId"></mat-datepicker-toggle>
                    <mat-datepicker #fromDateId></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-sm-2 col-xs-12">
                <mat-form-field style="width: 100%">
                    <mat-label>To</mat-label>
                    <input matInput [disabled]="progress" [formControl]="toDate" [matDatepicker]="toDateId" required>
                    <mat-datepicker-toggle matSuffix [for]="toDateId"></mat-datepicker-toggle>
                    <mat-datepicker #toDateId></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-sm-3 col-xs-12 padding-top-15">
                <mat-checkbox [disabled]="progress" [(ngModel)]="synchronizeMappings">
                    Synchronize mappings
                </mat-checkbox>
            </div>

            <div class="col-sm-2 col-xs-12">
                <button *ngIf="!isLoadingResults" (click)="reconcileJournals()" [disabled]="progress"
                        class="btn btn-primary btn-spinner" [class.transparent-button]="progress"
                        [disabled]="!selectedLocation || !fromDate.value || !toDate.value || fromDate.value > toDate.value || progress">
                    Reconcile Journals
                </button>
            </div>
        </div>

    </div>

</div>
